import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { AlpacaAccountInterface } from '@modules/alpaca-module/alpaca-account/interfaces/alpaca-account.interface'
import { PortfolioHistoryParamsInterface } from '@modules/alpaca-module/alpaca-account/interfaces/portfolio-history-params.interface'
import { PortfolioHistoryTimeframeEnum } from '@modules/alpaca-module/alpaca-account/enums/portfolio-history-timeframe.enum'
import { PortfolioHistoryIntradayReportingEnum } from '@modules/alpaca-module/alpaca-account/enums/portfolio-history-intraday-reporting.enum'
import { PortfolioHistoryPnlResetEnum } from '@modules/alpaca-module/alpaca-account/enums/portfolio-history-pnl-reset.enum'
import { PortfolioHistoryEngineVersionEnum } from '@modules/alpaca-module/alpaca-account/enums/portfolio-history-engine-version.enum'
import { PortfolioHistoryInterface } from '@modules/alpaca-module/alpaca-account/interfaces/portfolio-history.interface'
import { RiskLevelEnum } from '@modules/alpaca-module/alpaca-account/enums/risk-level.enum'

@Injectable({
	providedIn: 'root',
})
export class AlpacaAccountHelperService {
	protected readonly riskLevelEnum: typeof RiskLevelEnum = RiskLevelEnum

	public alpacaAccount$: BehaviorSubject<AlpacaAccountInterface | null> =
		new BehaviorSubject<AlpacaAccountInterface | null>(null)

	public portfolioHistory$: BehaviorSubject<PortfolioHistoryInterface | null> =
		new BehaviorSubject<PortfolioHistoryInterface | null>(null)
	public isLoadingPortfolioHistory$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)

	public portfolioHistoryParams$: BehaviorSubject<PortfolioHistoryParamsInterface> =
		new BehaviorSubject<PortfolioHistoryParamsInterface>({
			period: '1D',
			timeframe: PortfolioHistoryTimeframeEnum.ONE_MINUTE,
			intraday_reporting: PortfolioHistoryIntradayReportingEnum.EXTENDED_HOURS,
			pnl_reset: PortfolioHistoryPnlResetEnum.PER_DAY,
			force_engine_version: PortfolioHistoryEngineVersionEnum.V2,
		})

	public updateAlpacaAccount(newAlpacaAccount: Partial<AlpacaAccountInterface>, isDrop: boolean = false): void {
		if (isDrop) {
			this.alpacaAccount$.next(null)
			return
		}

		this.alpacaAccount$.next({
			...this.alpacaAccount$.getValue(),
			...newAlpacaAccount,
		} as AlpacaAccountInterface)
	}

	public calcActiveMarginLevel(marginLevel: number): number {
		if (marginLevel > 1.5) return 1
		if (marginLevel > 1.4) return 2
		if (marginLevel > 1.3) return 3
		if (marginLevel > 1.15) return 4
		if (marginLevel > 1.01) return 5
		return 6
	}

	public calcRiskLevel(activeMarginLevel: number): RiskLevelEnum {
		if (activeMarginLevel <= 1) return this.riskLevelEnum.low
		if (activeMarginLevel > 1 && activeMarginLevel <= 3) return this.riskLevelEnum.moderate
		if (activeMarginLevel > 3) this.riskLevelEnum.high
		return this.riskLevelEnum.low
	}

	public getBadgeAppearanceByRiskLevel(riskLevel: RiskLevelEnum): string {
		switch (riskLevel) {
			case this.riskLevelEnum.low:
				return 'positive'
			case this.riskLevelEnum.moderate:
				return 'warning'
			case this.riskLevelEnum.high:
				return 'negative'
			default:
				return 'positive'
		}
	}
}
